import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication.service';

/**
 * Navigation Menu component
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss'],
})
export class NavigationMenuComponent implements OnInit, AfterViewInit {
  iconName: string;
  /**
   * Menu DOM referenc
   */
  @ViewChild('menu', { read: ElementRef }) menu: ElementRef;

  /**
   * Trigger to pass filter object
   */
  @Output() isMenuOpenEvent: EventEmitter<any> = new EventEmitter();

  active: boolean = false;

  /**
   * Constructor
   */
  constructor(private authenticationService: AuthenticationService) {
    this.iconName = 'expand_more';
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {}

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    this.menu.nativeElement.style.width = window.innerWidth > 1280 ? '120px' : '0';
    this.isMenuOpenEvent.emit({ isMenuOpen: window.innerWidth > 1280 });
  }

  /**
   * Toggle menu
   *
   * @param event Boolean
   */
  toggleMenu(event: { toggleMenu: boolean }): void {
    this.menu.nativeElement.style.width = event.toggleMenu ? '120px' : '0';
  }

  isModuleAvailable(moduleId: string) {
    return this.authenticationService.isModuleAvailable(moduleId);
  }

  openSubmenu(data) {
    data.querySelector('.navigation-menu-component__submenu').style.display =
      data.querySelector('.navigation-menu-component__submenu').style.display === 'block' ? 'none' : 'block';

    this.iconName = this.iconName === 'expand_more' ? 'expand_less' : 'expand_more';
  }
}
